import { User } from '@/features/admin/types/user';
import { UserFormInputs } from '@/features/admin/types/user-form-inputs';
import { artiaProtectedApi } from '@/lib/api-client';
import { putWithValidation, RequestOptions } from '@/lib/api-helpers';

type UserRequest = {
  assignedClients: number[]
};

export const useUserService = () => {
  const getUsers = (): Promise<User[]> => {
    return artiaProtectedApi.get('users');
  };

  const getUser = (id: number): Promise<User> => {
    return artiaProtectedApi.get(`users/${id}`);
  };

  const updateUser = (id: number | string, { assignedClients }: UserFormInputs): Promise<any> => {
    const data: UserRequest = { assignedClients: assignedClients.map(client => client.id) };

    const options: RequestOptions<any> = {
      data
    };

    return putWithValidation(`users/${id}`, options);
  };

  return {
    getUsers,
    getUser,
    updateUser
  };
};
